import { fromJS } from 'immutable';
import { Reducer } from 'redux';

import { CLOSE, SHOW_ERROR, SHOW_MESSAGE } from './constants';

const initialState = fromJS({ message: '', error: '', open: false });

const notificationReducer: Reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MESSAGE:
      return state.merge({ open: true, message: action.message, error: '' });

    case SHOW_ERROR:
      return state.merge({ open: true, error: action.error, message: '' });

    case CLOSE:
      return state.set('open', false);

    default:
      return state;
  }
};

export default notificationReducer;
